import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-visa-review',
  templateUrl: './visa-review.component.html',
  styleUrls: ['./visa-review.component.scss'],
})
export class VisaReviewComponent  implements OnInit {

  visaId:any;
  visaDetails:any;

  visaLeadDetails:any;
  visaDocumentsDetails:any;
  visaImportantInformation:any;

  leadDetails:any;

  visaChecklistArray:any = [];
  visaNotesArray:any = []

  isLinkGenerated: boolean = false;
  
  constructor(
    private _modalController: ModalController,
    private _visaService: VisaService,
    private _leadService: LeadsService,
    private _globalService: GlobalService,
    private _modalService: ModalsService,
    private _responseNotificationService: ResponseNotificationService
  ) { }

  ngOnInit() {
    if(this.visaId){
      this._visaService.getVisa(this.visaId).subscribe((data)=>{
        this.visaDetails = data;
        this.visaLeadDetails = this.visaDetails?.visaLeadInfo;
        this.isLinkGenerated = this.visaLeadDetails?.documentCollectionLink ? true : false;
        this.visaImportantInformation = this.visaDetails?.importantInformation;
        this.visaDocumentsDetails = this.visaDetails?.visaDocuments;

        if(this.visaImportantInformation){
          this.visaChecklistArray = [...this.visaImportantInformation.mandatoryDocuments.data , ...this.visaImportantInformation.documentsBasedOnVisa.data, ...this.visaImportantInformation.otherDocuments.data];
          this.visaNotesArray = [...this.visaImportantInformation.keyPoints.data, ...this.visaImportantInformation.restrictedItems.data, ...this.visaImportantInformation.importantNotes.data, ...this.visaImportantInformation.detailsAboutStay.data];
        }
        
        if(this.visaDetails?.visaLeadInfo?.leadId){
          this.assignLeadDetails(this.visaDetails.visaLeadInfo.leadId);
        }
      })
    }
  }

  assignLeadDetails(leadId:any){
    this._leadService.getLead(leadId).subscribe((data)=>{
      this.leadDetails = data;      
    })
  }

  calculateAge(dateOfBirth: any){
    return this._globalService.calculateAge(dateOfBirth);
  }

  closeModal() {
    this._modalController.dismiss()
  }

  async editVisa(){
    await this._modalService.closeAllModals();
    this._modalService.openVisaCreationModal(this.visaLeadDetails.leadId, this.visaLeadDetails.visaId);
  }

  async generateDocumentLink(){
    const res = await this._globalService.getDocumentPdfLink("visalookup", this.visaId);
    const link = res.url;
    this.visaLeadDetails.documentCollectionLink = link;
    this._visaService.addVisaLeadInformation(this.visaLeadDetails).subscribe({
      next: (res:any)=>{
        this._responseNotificationService.showMessage("Link for Visa Documents upload is generated");
        // reload component VIsa lead details to show updated url
        this.ngOnInit();
      },
      error: (err:any)=>{
        console.error(err);
        this._responseNotificationService.showMessage("Failed to generate link, please try again later!", true);
      }
    })
  }

  copyTextToClipboard(text: any) {
    navigator.clipboard.writeText(text).then(() => {
      this._responseNotificationService.showMessage("Link copied to clipboard");
    }).catch(() => {
      this._responseNotificationService.showMessage("Failed to copy link", true);
    });
  }
}
